import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useTermsAgreement } from '../contexts/TermsAgreementContext';
import TermsOfService from '../pages/TermsOfService';

interface TermsAgreementDialogProps {
  open: boolean;
  onClose: () => void;
}

const TermsAgreementDialog: React.FC<TermsAgreementDialogProps> = ({ open, onClose }) => {
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { agreeToTerms } = useTermsAgreement();

  const handleAgree = async () => {
    if (!agreed) return;
    
    try {
      setIsSubmitting(true);
      await agreeToTerms();
      onClose();
    } catch (error) {
      console.error('Error saving terms agreement:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
    >
      <DialogTitle>
        Terms of Service Agreement
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          Please read and agree to our Terms of Service to continue using Amsler Grid Daily.
        </Alert>
        <Box sx={{ maxHeight: '60vh', overflow: 'auto', mb: 2 }}>
          <TermsOfService />
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              color="primary"
            />
          }
          label="I have read and agree to the Terms of Service"
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleAgree}
          color="primary"
          variant="contained"
          disabled={!agreed || isSubmitting}
        >
          {isSubmitting ? <CircularProgress size={24} /> : 'Agree & Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAgreementDialog; 